<template>
  <v-dialog v-model="showUserSharingDialog" max-width="600" persistent>
    <v-toolbar
      flat
      color="primary"
      class="text-capitalize primary-font-color"
      dense
    >
      <v-toolbar-title>{{ $translate('USERS') }}</v-toolbar-title>
      <v-spacer />
      <!-- Button to add products -->
      <v-btn
        color="secondary"
        class="text-capitalize secondary-font-color"
        @click="onAddUser"
      >
        <v-icon> mdi-account-plus</v-icon>{{ $translate('ADD_USER') }}
      </v-btn>
    </v-toolbar>
    <v-card class="pa-2">
      <v-list v-if="hasUsers">
        <v-list-item v-for="(item, i) in localRelationsAsParent" :key="i">
          <v-list-item-icon><v-icon>mdi-account</v-icon></v-list-item-icon>
          <v-list-item-title>{{ item.ChildEmailAddress }} </v-list-item-title>
          <v-spacer />
          <v-list-item-action>
            <v-btn text @click="onDeleteBtnClick(item)"
              ><v-icon color="red">delete</v-icon>
            </v-btn></v-list-item-action
          >
        </v-list-item>
      </v-list>
      <v-row v-if="!hasUsers" class="ma-4" style="justify-content: center">
        <span class="pa-6">
          {{ $translate('NO_USERS_FOUND') }}
        </span>
      </v-row>

      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="secondary"
          class="secondary-font-color"
          @click="onCloseDialog"
          >{{ $translate('CLOSE') }}</v-btn
        >
      </v-card-actions>
    </v-card>

    <!--add new user for sharing-->
    <template v-if="addNewUser">
      <v-dialog v-model="addNewUser" max-width="400">
        <v-card>
          <v-col>
            <v-card-title>
              {{ $translate('ADD_NEW_USER') }}
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="newUserData.Email"
                :label="$translate('ENTER_EMAIL')"
                :rules="emailRules"
                outlined
              >
              </v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="secondary"
                class="text-capitalize secondary-font-color"
                @click="addNewUser = false"
                >{{ $translate('CLOSE') }}</v-btn
              >
              <v-btn
                color="secondary"
                class="text-capitalize secondary-font-color"
                @click="addNewRelation(newUserData)"
              >
                {{ $translate('ADD') }}</v-btn
              >
            </v-card-actions>
          </v-col>
        </v-card>
      </v-dialog>
    </template>

    <!-- Dialog to confirm deleting a user -->
    <template v-if="showDeleteUserDialog">
      <ConfirmDialog
        :visible="showDeleteUserDialog"
        :title="deleteUserDialogTitle"
        :message="deleteUserDialogMsg"
        :positiveBtnText="$translate('YES')"
        :negativeBtnText="$translate('NO')"
        @positiveBtnClicked="deleteUserSharing"
        @negativeBtnClicked="showDeleteUserDialog = false"
      />
    </template>
  </v-dialog>
</template>
<script>
import UserParentChildRelations from '@/objects/UserParentChildRelations';
import { cloneDeep } from 'lodash';
import ConfirmDialog from '@/components/generalComponents/uiComponents/ConfirmDialog.vue';
export default {
  name: 'ShareShoppingList',
  components: { ConfirmDialog },
  props: {
    showUserSharingDialog: {
      type: Boolean,
      default: false,
    },
    userRelationsAsParent: {
      type: Object,
      default: () => {},
    },
  },
  component: {
    ConfirmDialog,
  },
  watch: {
    userRelationsAsParent() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      addNewUser: false,
      hasUsers: false,
      newUserData: {},
      localRelationsAsParent: {},
      showDeleteUserDialog: false,
      itemToDelete: {},
      deleteUserDialogTitle: this.$translate('DELETE_USER'),
      deleteUserDialogMsg: this.$translate('ACCOUNT_DELETE_USER'),
      emailRules: [
        (v) => !!v || this.$translate('EMAIL_REQUIRED'),
        (v) => /.+@.+\..+/.test(v) || this.$translate('EMAIL_VALID'),
      ],
    };
  },
  methods: {
    init() {
      if (this.userRelationsAsParent != null) {
        this.localRelationsAsParent = {
          ...cloneDeep(this.userRelationsAsParent),
        };
      }
      if (Object.keys(this.localRelationsAsParent).length > 0)
        this.hasUsers = true;
    },
    onAddUser() {
      this.addNewUser = true;
      this.newUserData = {
        Email: '',
        Url: '',
      };
    },
    async addNewRelation(data) {
      let relationObj = new UserParentChildRelations();
      try {
        await relationObj.requestNewChildRelation(data);
        this.addNewUser = false;
        this.onCloseDialog();
      } catch (error) {
        console.log('error', error);
      }
    },
    onCloseDialog() {
      this.$emit('close');
    },
    onDeleteBtnClick(item) {
      this.itemToDelete = {};
      this.showDeleteUserDialog = true;
      this.itemToDelete = item;
    },
    async deleteUserSharing() {
      let relationObj = new UserParentChildRelations();
      try {
        await relationObj.removeUserUserRelation(this.itemToDelete);
      } catch (error) {
        console.log('ERROR', error);
      }
      this.showDeleteUserDialog = false;
      this.itemToDelete = {};
      this.onDeleteRefreshList();
    },
    onDeleteRefreshList() {
      this.$emit('refreshShoppingList');
    },
  },
};
</script>
<style scoped lang="scss"></style>
